import React, { useEffect, useState } from "react";
import UserPageLayout from "../../../../components/UserPageLayout";
import { useAppContext } from "../../../../../../context/AppContext";
import { useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { LicenceData } from "../../../../network/api/LicenceData";
import Toast from "../../../../../../components/Toast";
import { decodeId ,encodeId } from "../../../../../../utils/hash";
import EADetailsCard from "../../components/EADetailsCard";
import CardLoader from "../../../../../../components/CardLoader";


export default function Licence() {
    const navigate = useNavigate();
    const { setPageTitle, setPageUserID } = useAppContext();
    const { id: licenceI } = useParams();
    const licenceId = decodeId(licenceI);

    const [pageLoading, setPageLoading] = useState(false);
    const [pageErrorMessage, setPageErrorMessage] = useState(null);

    const [licence, setLicence] = useState(null);
    const [expert, setExpert] = useState(null);
    const [reload, setReload] = useState(false);


    const [toastConfig, setToastConfig] = useState({ visible:false, message: "", type: "primary" });


    const handleStatusChange = (value) => {
        updateLicenceData({ field: "status", value: value });
    };

    const handleReuse = () => {
        updateLicenceData({ field: "reuse", value: true });
    };

    const handleDelete = async () => {
        setPageLoading(true);
        setPageErrorMessage(null);
        try {
            const response = await LicenceData({ method: "DELETE", id: licence?.id });

            setToastConfig({
                visible: true,
                message: `${response.message} \n\r deleting ${licence?.k_ey}`,
                type: response.status === "success" ? "success" : "danger"
            });
            if (response.status === "success") {
                setTimeout(() => {
                    navigate(`/eas/${encodeId(licence?.ea)}`);
                }, 1000);
            }
        }
        catch (err) {
            setToastConfig({
                visible: true,
                message: err.message || "Failed to Delete Licence Data.",
                type: "danger"
            });
        } finally {
            setPageLoading(false);
        }
    };

    const updateLicenceData = async ({ field, value }) => {
        setPageLoading(true);
        setPageErrorMessage(null);
        try {
            const response = await LicenceData({ method: "PUT", formData: { id: licence?.id, [field]: value } });
            setToastConfig({
                visible: true,
                message: `${response.message} \n\r updating ${field} to ${value}`,
                type: response.status === "success" ? "success" : "danger"
            });
            if (response.status === "success") {
                setReload(!reload);
            }
        } catch (err) {
            setToastConfig({
                visible: true,
                message: err.message || "Failed to Update Licence Data.",
                type: "danger"
            });
        } finally {
            setPageLoading(false);
        }
    }

    useEffect(() => {
        const fetchLicenceData = async () => {
            setPageLoading(true);
            setPageErrorMessage(null);

            if (!licenceId) {
                setPageLoading(false);
                setPageErrorMessage({ code: 401, message: "No user ID found." });
                return;
            }

            try {
                const response = await LicenceData({ method: "GET", id: licenceId });

                if (response.status === "success") {
                    setLicence(response.data);
                    setPageUserID(response.data.owner);
                } else {
                    setPageErrorMessage({ code: response.code, message: response.message });
                }
            } catch (err) {
                setPageErrorMessage({ code: 500, message: err.message || "Failed to load Licence Data." });
            } finally {
                setPageLoading(false);
            }
        };
        fetchLicenceData();
    }, [licenceId, reload, setPageUserID]);

    useEffect(() => {
        setPageTitle("Licence Key");
    }, [setPageTitle]);

    return (
        <UserPageLayout>
            <Toast message={toastConfig.message}
                type={toastConfig.type}
                visible={toastConfig.visible}
                setVisible={(visible) => setToastConfig({ ...toastConfig, visible })}
            />
            <div className="content-body">
                <div className="container-fluid">
                    <div className="row page-titles">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item  "><Link to={`/eas/${encodeId(licence?.ea)}`}>EA Details</Link></li>
                            <li className="breadcrumb-item  active"><span>Licence key</span></li>
                        </ol>
                    </div>


                    <div className="row">
                        <div className="col-xl-8">
                            <div className="card shadow border-0">
                                {(pageLoading || pageErrorMessage) && (<CardLoader errorMessage={pageErrorMessage} onRetry={() => { setReload(!reload); }} />)}
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-7  d-flex flex-column justify-content-center">
                                            <div className="ps-xl-4">
                                                <p className="card-title ">Licence Details</p>
                                                <h1 className="text-primary">{licence?.k_ey}</h1>
                                                <sup className={`badge bg-info me-2`}>{licence?.type}</sup>
                                                <sup className={`badge bg-${licence?.status === "Active" ? "success" : "danger"} me-2`}>{licence?.status}</sup>
                                                <sup className={`badge ${licence?.used ? "bg-primary" : "bg-secondary"}`}>
                                                    {licence?.used ? "Used" : "Unused"}
                                                </sup>
                                                <h3 className="fw-medium mb-xl-4 text-primary mt-2">{expert?.name}</h3>
                                                <p className="mb-2 mb-xl-0">
                                                    This is a licence key of EA <strong>{expert?.name || "Expert"} </strong>. Share it with the user to grant them access to the app.
                                                </p>
                                                <div className="mt-3">
                                                    <button className="btn btn-outline-primary btn-sm" >
                                                        <i className="fas fa-sync-alt me-2"></i>Reuse Licence
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-5   d-flex justify-content-end pe-xl-4">
                                            <div className="w-100 text-end d-flex flex-column justify-content-center" style={{ maxWidth: "400px" }}>
                                                <div className="row">
                                                    <div className="col-md-12 mt-4">
                                                        <h3 className={`fw-semibold text-${licence?.status === "Active" ? "success" : "danger"}`}>{licence?.user}</h3>
                                                        {licence?.email ?
                                                            <h5 className="fw-normal">Email: {licence?.email}</h5> : <></>
                                                        }
                                                        <h5 className="fw-normal">{licence?.plan} days plan</h5>
                                                        <h5 className="fw-normal">Created Date: {new Date(licence?.created).toLocaleDateString()}</h5>
                                                        <h5 className="fw-normal">Expiry Date: {new Date(licence?.expires).toLocaleDateString()}</h5>


                                                    </div>
                                                    <div className="card-footer mx-0 px-0 d-flex mt-4 justify-content-end gap-3">
                                                        <button className={`btn btn-outline-${licence?.status === "Active" ? "warning" : "success"} btn-sm`}
                                                            onClick={() => handleStatusChange(`${licence?.status === "Active" ? "Expired" : "Active"}`)}>
                                                            <i className="fas fa-ban me-2"></i>{licence?.status === "Active" ? "Deactivate" : "Activate"}
                                                        </button>
                                                        <button className="btn btn-outline-danger btn-sm" onClick={handleDelete}>
                                                            <i className="fas fa-trash-alt me-2"></i>Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-4 col-lg-12 col-sm-12">
                            <EADetailsCard eaId={licence?.ea} setExpert={setExpert} expert={expert} showImage={true} showFooterStats={false} showGButton={true}/>
                        </div>
                    </div>

                </div>
            </div>

        </UserPageLayout>
    );
}
